import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAllRates = (queryParams) => {
	const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

	return axiosInstance({
		url: config.routes.rates,
		method: "get",
		headers: {
			Authorization: `Bearer ${token}`,
		},
		params: queryParams,
	});
};

export const createRate = (data) => {
	const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

	return axiosInstance({
		url: config.routes.createRate,
		method: "post",
		headers: {
			Authorization: `Bearer ${token}`,
		},
		data: data,
	});
};
